//
//
//
//

export default {
    name: "weekReportDetail",
  created() {
    this.$router.push({path:'/'})
  }
}




// WEBPACK FOOTER //
// ./src/view/weekReport/weekReportDetail.vue